(function () {
  'use strict';

  function startSlideshow(el) {
    if (el.dataset.iwtInit === 'true') return;

    var slides = el.querySelectorAll('.qikify-iwt-slide');
    if (slides.length < 2) return;

    el.dataset.iwtInit = 'true';

    var interval = parseInt(el.dataset.iwtInterval, 10);
    if (!interval || interval < 500) interval = 3000;

    var current = 0;
    setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, interval);
  }

  function initSlideshows(root) {
    var scope = root || document;
    var slideshows = scope.querySelectorAll('[data-iwt-slideshow]');
    for (var i = 0; i < slideshows.length; i++) {
      startSlideshow(slideshows[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSlideshows();
    });
  } else {
    initSlideshows();
  }

  // Re-init when a section is (re)rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    initSlideshows(event.target);
  });
})();
